import { render } from "./KPIChange.vue?vue&type=template&id=cbadb20e&scoped=true"
import script from "./KPIChange.vue?vue&type=script&lang=js"
export * from "./KPIChange.vue?vue&type=script&lang=js"

import "./KPIChange.vue?vue&type=style&index=0&id=cbadb20e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbadb20e"]])

export default __exports__